import { useState } from "react";
import { useAuth } from "@/lib/auth";
import { DailyLogsTab } from "@/components/pm/DailyLogsTab";
import { JobDiary } from "@/components/JobDiary";

export function JobDiaryWorkspace({ job }) {
  const { user } = useAuth();
  const fullDiary = ["admin", "office", "super_admin"].includes(user.role);
  const [showSummaries, setShowSummaries] = useState(false);
  if (!fullDiary) return <JobDiary jobId={job.id} />;
  return <div className="space-y-5" data-testid="job-diary-workspace">
    <p className="text-sm text-muted-foreground">Keep the daily site record here. Use auto-fill to bring in site activity, review the entry, then download or send it. Automatic sending uses the existing diary settings.</p>
    <DailyLogsTab key={job.id} jobId={job.id} project={job} />
    <details onToggle={event => setShowSummaries(event.currentTarget.open)} className="border-t border-border pt-3">
      <summary className="cursor-pointer py-2 text-sm font-medium">Activity summaries &amp; previous Job diary entries</summary>
      <p className="text-sm text-muted-foreground my-3">The earlier Job diary creates text summaries from site activity. Those records and their editing tools are kept here. They are separate from the daily logs above and are not included in automatic diary emails.</p>
      {showSummaries && <JobDiary jobId={job.id} title="Activity summaries" />}
    </details>
  </div>;
}
